import { Routes } from '@angular/router';
import { AuthGuard } from '@core/guards/auth.guard';
import { ControlAccessGuard } from '@core/guards/control-access.guard';
import { LayoutAuthComponent } from './core/layouts/layout-auth/layout-auth.component';
import { LayoutNoAuthComponent } from './core/layouts/layout-no-auth/layout-no-auth.component';
import {PaginaSemAutorizacaoComponent} from '@core/layouts/componentes/pagina-sem-autorizacao/pagina-sem-autorizacao.component';
import { MaxMinYearPermissionGuard } from '@core/guards/max-min-year-permission.guard';

export const APP_ROUTES: Routes = [
  {
    path: 'auth',
    component: LayoutNoAuthComponent,
    loadChildren: () =>
      import('./modules/auth/auth.module').then((m) => m.AuthModule),
    data: { breadcrumb: null },
  },
  {
    path: '',
    component: LayoutAuthComponent,
    data: { breadcrumb: null },
    canActivate: [AuthGuard, ControlAccessGuard],
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./modules/home/home.module').then((m) => m.HomeModule),
        data: { breadcrumb: null },
      },
      {
        path: 'configuracao',
        loadChildren: () =>
          import('./modules/configuracao/configuracao.module').then(
            (m) => m.ConfiguracaoModule
          ),
        data: { breadcrumb: 'Configurações' },
      },
      {
        path: 'meus-dados',
        loadChildren: () =>
          import('./modules/meus-dados/meus-dados.module').then(
            (m) => m.MeusDadosModule
          ),
        data: { breadcrumb: 'Atualização de Informações Pessoais' },
      },
      {
        path: 'diario',
        loadChildren: () =>
          import('./modules/diario/diario.module').then(
            (m) => m.DiarioModule
          ),
        data: { breadcrumb: 'Diário'}
      },
      // MENU OCULTADO PARA ENTREGA 113
      // {
      //   path: 'readaptacao',
      //   canActivate: [MaxMinYearPermissionGuard],
      //   loadChildren: () =>
      //     import('./modules/readaptacao/readaptacao.module').then(
      //       (m) => m.ReadaptacaoModule
      //     ),
      //   data: { breadcrumb: 'Readaptação', minYear: 2025 }
      // }
    ],
  },
  {
    path: 'sem-permissao',
    component: PaginaSemAutorizacaoComponent,
  },
];
